import React from "react";
import { gql } from "@apollo/client";

import { Box, Tabs, Tab } from "@mui/material";

import ColissimoForm from "./colissimo";
import DelivengoForm from "./delivengo";
import FedexForm from "./fedex";
import CustomForm from "./custom";

export default function OrderActionShipment({ order, onSubmitted }) {
  const [activeTab, setActiveTab] = React.useState("fedex");

  return (
    <>
      <Tabs
        value={activeTab}
        onChange={(evt, tabName) => setActiveTab(tabName)}
        variant="fullWidth"
        indicatorColor="primary"
        sx={{
          m: (t) => t.spacing(-2, -2, 0),
          borderBottom: (t) => `1px solid ${t.palette.divider}`,
        }}
      >
        <Tab value="colissimo" label="Colissimo" />
        <Tab value="delivengo" label="Delivengo" />
        <Tab value="fedex" label="FedEx" />
        <Tab value="custom" label="Tracking ID" />
      </Tabs>

      <Box mt={2}>
        {activeTab === "colissimo" && (
          <ColissimoForm order={order} onSubmitted={onSubmitted} />
        )}

        {activeTab === "delivengo" && (
          <DelivengoForm order={order} onSubmitted={onSubmitted} />
        )}

        {activeTab === "fedex" && (
          <FedexForm order={order} onSubmitted={onSubmitted} />
        )}

        {activeTab === "custom" && (
          <CustomForm order={order} onSubmitted={onSubmitted} />
        )}
      </Box>
    </>
  );
}

OrderActionShipment.fragments = {
  order: gql`
    fragment OrderActions_Shipment_order on Order {
      id

      ...OrderShipmentColissimoForm_order
      ...OrderShipmentDelivengoForm_order
      ...OrderShipmentFedexForm_order
    }

    ${ColissimoForm.fragments.order}
    ${DelivengoForm.fragments.order}
    ${FedexForm.fragments.order}
  `,
};
